import React from 'react'
import Calculator from './index'

const CalculatorFormInnerPage = () => <Calculator layout='grid' />

export default CalculatorFormInnerPage
